import { render, staticRenderFns } from "./Haccp.vue?vue&type=template&id=7c4146b3&scoped=true"
import script from "./Haccp.vue?vue&type=script&lang=js"
export * from "./Haccp.vue?vue&type=script&lang=js"
import style0 from "./Haccp.vue?vue&type=style&index=0&id=7c4146b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4146b3",
  null
  
)

export default component.exports